import React from 'react';

export default function ShippingPolicy() {
  return (
    <div className="policy-page" style={{
      maxWidth: '900px',
      margin: '20px auto',
      background: '#ffffff',
      borderRadius: '12px',
      padding: '24px',
      boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
    }}>
      <h1 style={{ marginTop: 0 }}>Shipping Policy</h1>

      <p>
        We aim to deliver your orders quickly and safely across India.
      </p>

      <h3>Delivery Timeline</h3>
      <p>
        The products would be delivered to the customer's within <strong>4 to 6 days</strong>.
      </p>

      <h3>Order Processing</h3>
      <ul>
        <li>Orders are typically processed within 24–48 hours on business days.</li>
        <li>Processing and delivery may be affected during holidays or due to unforeseen logistics delays.</li>
      </ul>

      <h3>Tracking</h3>
      <p>
        Once shipped, you will receive tracking details via email/SMS (where available).
      </p>

      <h3>Support</h3>
      <p>
        For any shipping queries, write to <a href="mailto:support@shopiebazar.com">support@shopiebazar.com</a>
        or call <a href="tel:+911169266020">+91 1169266020</a>.
      </p>

      <p style={{ opacity: 0.8, fontSize: '12px' }}>
        Note: This policy is subject to change. Please refer to this page for the latest version.
      </p>
    </div>
  );
}
